import type { User } from "../types";

/**
 * Identify DD user session from a ControlTower User
 * See https://docs.datadoghq.com/real_user_monitoring/browser/advanced_configuration/?tab=npm#identify-user-session
 *
 * @param user The ControlTower user
 */
export async function setDatadogUser(user: User) {
  const { datadogRum } = await import("@datadog/browser-rum");
  datadogRum.setUser(user as User & { [key: string]: unknown });
}

/**
 *
 * Clear all Datadog user information
 */
export async function resetDatadogUser() {
  const { datadogRum } = await import("@datadog/browser-rum");
  datadogRum.clearUser();
}
